import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Guía Rápida de Emergencia',
    desc: 'Qué hacer cuando el scooter falla en la calle. Diagnóstico en 5 minutos con tu celular.',
    value: '$8.000'
  }, {
    title: 'Calendario de Mantenimiento Imprimible',
    desc: 'Tu plan anual de revisiones listo para colgar. Nunca más olvidés qué revisar ni cuándo.',
    value: '$6.000'
  }, {
    title: 'Glosario Técnico Ilustrado',
    desc: 'Todos los términos técnicos explicados en lenguaje simple. Hablá con cualquier técnico sin que te tomen el pelo.',
    value: '$5.000'
  }];
  return <section className="py-20 px-4 bg-gradient-to-b from-background to-surface/50" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-19">
            🎁 3 BONOS ESTRATÉGICOS
          </h2>
          <div className="inline-block bg-brand/10 text-brand font-bold px-6 py-2 rounded-full border border-brand/20" data-id="element-20">
            SIEMPRE INCLUIDOS
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-21">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-surface border border-border rounded-2xl p-6 relative overflow-hidden group hover:border-brand/50 transition-colors" data-id="element-22">
              <div className="absolute -right-6 -top-6 text-brand/5 group-hover:text-brand/10 transition-colors" data-id="element-23">
                <Gift size={120} data-id="element-24" />
              </div>
              <div className="relative z-10" data-id="element-25">
                <div className="text-brand font-bold mb-2" data-id="element-26">BONO {idx + 1}</div>
                <h3 className="text-xl font-heading font-bold text-white mb-3" data-id="element-27">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 mb-6 min-h-[80px]" data-id="element-28">{bonus.desc}</p>
                <div className="flex items-center gap-3 font-bold" data-id="element-29">
                  <span className="text-danger line-through" data-id="element-30">
                    {bonus.value}
                  </span>
                  <span className="text-brand text-xl" data-id="element-31">→ GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-surface border-2 border-brand/30 rounded-2xl p-6 text-center max-w-2xl mx-auto" data-id="element-32">
          <div className="text-xl md:text-2xl font-bold" data-id="element-33">
            <span className="text-white" data-id="element-34">Valor total bonos </span>
            <span className="text-danger line-through mx-2" data-id="element-35">$19.000</span>
            <span className="text-brand" data-id="element-36">→ GRATIS con tu MegaPack</span>
          </div>
        </motion.div>
      </div>
    </section>;
}